const Homepage = () => {
    return (
        <div className='homepage'>
            <div className='container-md mb-5'>
                <div className='row'>
                    <div className="col-xl-8 offset-xl-2 col-lg-10 offset-lg-1">
                        <h1 className='header'>SPARCs-Box</h1>
                        <hr className="small"/>
                        <span className="page-subheading">Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio voluptatibus a tenetur eaque rem fugit, dolorem eveniet placeat autem! Asperiores ex pariatur sint unde soluta inventore ut quia distinctio non.</span>
                    </div>
                </div>
            </div>
            <div className=" container-md " role="main">
                <div className="row">
                    <div className="home-content col-xl-8 offset-xl-2 col-lg-10 offset-lg-1">
                        <p className='mb-5'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Eius nulla sunt laudantium, maxime nam, possimus iure, enim harum in culpa dolore molestias. Cumque tenetur animi nobis eos, repellendus perferendis dolor.
                        Aliquam voluptatibus expedita amet, quaerat id voluptate possimus atque nobis harum officia debitis sint quibusdam perspiciatis nulla neque, ipsam aliquid veniam porro? Cumque debitis vel error tenetur cum voluptas vitae.
                        Eaque in, saepe iste, asperiores praesentium rem dolor omnis similique distinctio dolore natus incidunt doloremque fugit odit minus aperiam unde? Nam ullam odio, illo explicabo eum fugiat iste velit aspernatur?</p>

                        <img src='https://diypbx.com/wp-content/uploads/2016/02/video-placeholder.jpg'/>

                        <p className='mt-5'>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Neque accusamus rerum recusandae maxime ut beatae debitis at vero numquam cupiditate esse officiis dolor dolorem quod non iure, ex quae optio?
                        Vel ipsa blanditiis non culpa laborum, beatae odit provident sapiente quaerat pariatur voluptatem accusamus voluptates animi similique dolores impedit! Quidem, eos? Tenetur laudantium alias quasi labore tempora, nesciunt totam cupiditate?
                        Tempore dolore aperiam rem aliquam similique nulla sapiente ratione commodi non fugit, molestiae, minima aspernatur eaque in ipsam est obcaecati facere cum dicta eos? Iste, provident recusandae! Aliquid, fugit blanditiis!</p>
                    </div>
                </div>
            </div>
        </div>
        
    );
}

export default Homepage